import { render } from "./VehicleWithdrawalDepots.vue?vue&type=template&id=22c6beb2"
import script from "./VehicleWithdrawalDepots.vue?vue&type=script&lang=ts"
export * from "./VehicleWithdrawalDepots.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
